import { useState } from "react";
import "./styles.css";

import icon from "../../assets/icontel.png";

const CtaTel = () => {
  const [text, setText] = useState("(41) 99112-3598");

  return (
    <button id="ctaTel">
      <a href="tel:991123598">
        <figure>
          <img src={icon} alt="Ícone do Telefone" />
        </figure>
        <p>{text}</p>
      </a>
    </button>
  );
};

export default CtaTel;
